import React from 'react';
import {Icon, Label} from 'semantic-ui-react';

import * as handlers from './handlers';
import {Props} from './types';

import './index.scss';

const SearchArea = (props: Props) => {
  return (
    <div className="a__search-area">
      <div className="b__search-title">検索キーワード</div>
      <div className="w__keywords">
        {props.searchWords.map((keyword: any, index: number) => {
          return (
            <div className="b__search-word" key={index}>
              <Label
                onClick={() => {
                  handlers.removeWord(
                    keyword,
                    props.searchWords,
                    props.formProps,
                    props.name
                  );
                }}
              >
                <span className="b__text">{keyword.text}</span>
                <Icon name="delete" />
              </Label>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SearchArea;
